export function Eyebrow({ children, className = "" }) {
  return <span className={`overline-label ${className}`}>{children}</span>;
}

export function Section({ children, className = "", id }) {
  return (
    <section id={id} className={`max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 ${className}`}>
      {children}
    </section>
  );
}

export function DisclaimerNote({ text, className = "" }) {
  return (
    <p
      className={`text-xs text-stone-500 leading-relaxed flex gap-2 ${className}`}
      data-testid="disclaimer-note"
    >
      <i className="fa-solid fa-circle-info mt-0.5 text-stone-400" />
      <span>{text}</span>
    </p>
  );
}
